import { useState } from "react";
import { downloadQmFile } from "./api";

interface Props {
  slug: string | null;
  handbuchContent: string;
  onNew: () => void;
}

export function Step4Download({ slug, handbuchContent, onNew }: Props) {
  const [docxBusy, setDocxBusy] = useState(false);
  const [pdfBusy, setPdfBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleDocx() {
    if (!slug) return;
    setError(null);
    setDocxBusy(true);
    try {
      const result = await downloadQmFile(slug, "docx");
      if (!result.ok) setError(result.error ?? "DOCX-Generierung fehlgeschlagen");
    } finally {
      setDocxBusy(false);
    }
  }

  async function handlePdf() {
    if (!slug) return;
    setError(null);
    setPdfBusy(true);
    try {
      const result = await downloadQmFile(slug, "pdf");
      if (!result.ok) setError(result.error ?? "PDF-Generierung fehlgeschlagen");
    } finally {
      setPdfBusy(false);
    }
  }

  function handleMarkdown() {
    if (!slug) return;
    const blob = new Blob([handbuchContent], { type: "text/markdown" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `qm_handbuch_${slug}.md`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  return (
    <section className="wizard-section" data-qm-step="4">
      <h2 className="form-title">QM Handbuch: Herunterladen</h2>
      <p className="form-description">
        Das QM-Handbuch ist fertig. Lade es als DOCX, PDF oder Markdown herunter.
      </p>
      {error && (
        <div className="info-box" role="alert" style={{ marginBottom: "0.75rem" }}>
          {error}{" "}
          <button type="button" className="link-button" onClick={() => setError(null)}>
            Schließen
          </button>
        </div>
      )}
      <div className="form-actions" style={{ gap: "0.75rem", flexWrap: "wrap" }}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => void handleDocx()}
          disabled={!slug || docxBusy}
        >
          {docxBusy ? "Generiere DOCX…" : "Download DOCX"}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => void handlePdf()}
          disabled={!slug || pdfBusy}
        >
          {pdfBusy ? "Generiere PDF…" : "Download PDF"}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleMarkdown}
          disabled={!slug}
        >
          Download Markdown
        </button>
        <button type="button" className="btn btn-secondary" onClick={onNew}>
          Neues QM Handbuch
        </button>
      </div>
    </section>
  );
}
